import { Subject } from 'rxjs'
import { Message } from 'components/message'
import { CestaService } from '../../../cesta/cesta.service'
import { PbmZicardService } from './pbm-zicard.service'
import { ModalPbmObserver } from '../modal-pbm.observer'
import { AdicionarCestaObserver } from '../../../cesta/adicionar/adicionarCesta.observer'
import { ModalPbmComponent } from "../modal-pbm.component";

export class PbmZicardComponent {
  constructor(data) {
    this.data = data;
    this.cestaService = new CestaService();
    this.pbmZicardService = new PbmZicardService();
    this.alert = new Message();
    this.modalPbm = new ModalPbmComponent();
    this.cancelar = document.getElementById("cancelar-desconto").addEventListener("click", this.buildCancelar); 
    this.closeAlertButton = document.getElementById("close-alert").addEventListener("click", this.closeAlert); 
    this.init();
  }

  init() {
    if (this.data.consultaPreco) {
      this.consultaPreco()
    } else {
      this.preAutorizar()
    }
  }

  closeAlert(){
    document.getElementById('aviso-pbm').hidden = true
  }

  consultaPreco() {
    return this.pbmZicardService
      .consultaPreco(this.data)
      .subscribe(this.consultaPrecoResponse())
  }

  preAutorizar() {
    return this.pbmZicardService
      .preAutorizacao(this.data)
      .subscribe(this.preAutorizarResponse())
  }

  consultaPrecoResponse() {

    return {

      next: response => {

        if (response.status) {
                        
          switch (response.status) {
            case 200: {
              this.consultaPrecoResponseSuccess(response.data)
              break;
            }
            case 206:
              this.cadastrar();
              break;
            default: {

              break;
            }
          }
        } else {
          this.alert.message = "Erro ao validar desconto PBM, tente novamente!";
          this.alert.show();
        }
      },

      error: error => {
        if (error && error.data && this.validaLimiteAutorizadoDosItens(error.data)) {
          this.buildItensComErros(error.data);
          return
        }

        let msg = "Verifique seus dados e tente novamente";
        if (error) {
          if (error.status) {
            if ((error.status == 400 || error.status == 404) && error.data && Array.isArray(error.data)) {
              msg = error.data.map((elem) => elem.message).join(", ")
            } else if ((error.status == 400 || error.statuconsultaPrecoResponses == 404) && error.data && error.data.mensagem) {
              msg = error.data.mensagem;
            }

            if (!error.data) msg = "Não foi possível autorizar este item"
          }
        }

        this.alert.message = msg;
        this.alert.show();
      },

      complete: () => console.log('Complete')

    }
  }


  consultaPrecoResponseSuccess(preAutorizacao) {

    if (preAutorizacao.itens.length > 0 && preAutorizacao.itens != null) {
      
      const numberFormat = Intl.NumberFormat('pt-BR', {style:'currency', currency:'BRL'});
      const showInCpf = document.querySelectorAll('.show-in-cpf')	
      const isNotPbm = document.querySelectorAll('.is-not-pbm')	

      document.getElementById('pbm-quantidade').textContent = "(QTDE " + preAutorizacao.itens[0].quantidadePreAutorizada + ")"
      document.getElementById('pbm-quantidade-alert').textContent = preAutorizacao.itens[0].quantidadePreAutorizada
      document.getElementById('pbm-valor').textContent = numberFormat.format(preAutorizacao.itens[0].precoLiquidoPreAutorizado)
      document.getElementById('item-price-pbm-card').style.height = "400px"

      if (document.getElementById('pontuacao-autorizada') != null) {
        document.getElementById('pontuacao-autorizada').style.display = 'block'
        document.getElementById('titulo').style.display = 'none'
        document.querySelector('.item-price-pbm-menor-preco').style.color = '#676767'
      }
 
      if(showInCpf != null){
        Array.prototype.forEach.call(isNotPbm, q => {	
          q.hidden = !q.hidden	
        })	
      }

      if(isNotPbm != null){
        Array.prototype.forEach.call(showInCpf, c => {	
          c.hidden = !c.hidden	
        })
      }

      this.buildAutorizar()
      this.modalPbm.closeAll()
    }

  }

  buildAutorizar(origem){
    const itens = document.getElementsByClassName('pbm-item-melhor-preco')
    document.getElementById('loreal-register-button').hidden = !document.getElementById('loreal-register-button').hidden
    document.getElementById('item-price-pbm-card').style.height = "370px"
    return Array.prototype.forEach.call(itens, q => {
        q.hidden = !q.hidden
    })
  }

  buildCancelar(){
    window.location.reload();
  }

  preAutorizarResponse() {
    return {
      next: response => {
        if (response.status) {
          switch (response.status) {
            case 200: {
              this.preAutorizarResponseSuccess(response.data)
              break;
            }
            case 206:
              this.cadastrar();
              break;
            default: {

              break;
            }
          }
        } else {
          this.alert.message = "Erro ao validar desconto PBM, tente novamente!";
          this.alert.show();
        }
      },
      error: error => {
        if (error && error.data && this.validaLimiteAutorizadoDosItens(error.data)) {
          this.buildItensComErros(error.data);
          return
        }

        let msg = "Verifique seus dados e tente novamente";
        if (error) {
          if (error.status) {
            if ((error.status == 400 || error.status == 404) && error.data && Array.isArray(error.data)) {
              msg = error.data.map((elem) => elem.message).join(", ")
            } else if ((error.status == 400 || error.status == 404) && error.data && error.data.mensagem) {
              msg = error.data.mensagem;
            }

            if (!error.data) msg = "Não foi possível autorizar este item"
          }
        }

        this.alert.message = msg;
        this.alert.show();
      },
      complete: () => console.log('Complete')
    }
  }

  preAutorizarResponseSuccess(preAutorizacao) {
    this.cestaService.getCarrinho().subscribe(new AdicionarCestaObserver());
  }

  cadastrar() {
    document.getElementById('loreal-register-button').click()
  }

  buildModalSuccessData(preAutorizacao) {
    const item = this.buildItemFromPreAutorizacao(preAutorizacao);
    const valorAntigo = Number(this.data.preco).toFixed(2);
    return {
      step: "success",
      valorAntigo: valorAntigo,
      valorNovo: item.precoLiquidoPreAutorizado.toFixed(2),
      valorDesconto: ((valorAntigo - item.precoLiquidoPreAutorizado)).toFixed(2),
      mensagem: (this.data.quantidadeSolicitada > item.quantidadePreAutorizada) ? this.buildMensagemQuantidade(item) : null
    }
  }

  buildMensagemQuantidade(item) {
    return `Você solicitou ${this.data.quantidadeSolicitada} unidades e foi autorizado ${item.quantidadePreAutorizada} unidades.`
  }

  buildItemFromPreAutorizacao(preAutorizacao) {
    return preAutorizacao
      .itens
      .filter(item => item.codigoItem == this.data.item)[0]
  }

  validaLimiteAutorizadoDosItens(preAutorizacao) {
    if (!preAutorizacao.itens) return false;

    return preAutorizacao
      .itens
      .filter(item => item.statusPreAutorizacao === false)
      .filter(item => item.mensagem != "")
  }

  buildItensComErros(preAutorizacao) {
    const msgs = preAutorizacao
      .itens
      .filter(item => item.statusPreAutorizacao === false)
      .filter(item => item.mensagem != "")
      .map(item => item.mensagem);
    if (msgs) {
      this.alert.message = msgs.join("\r\n");
      this.alert.show();
    }
  }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-zicard/pbm-zicard.component.js